import { ReactNode } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import ArrowPathIcon from '@flipster/react/icon/generated/ArrowPathIcon';
import DownloadIcon from '@flipster/react/icon/generated/DownloadIcon';
import { flex } from '@flipster/styled-system/patterns';

import { useIsWebview } from '../../shared/webview';
import { description } from './styles';

interface Props {
  desc?: ReactNode;
  refetch?: () => void;
  onClickExport?: () => void;
}

const ActionButtons = ({ desc, refetch, onClickExport }: Props) => {
  const isWebview = useIsWebview();

  if (isWebview) return null;

  return (
    <div
      className={flex({ gap: 12, align: 'center', w: { base: '100%', tablet: 'auto' }, _empty: { display: 'none' } })}
    >
      {(desc || refetch) && (
        <div className={flex({ align: 'center', gap: 12, display: { tabletDown: 'none' } })}>
          {desc && <span className={description}>{desc}</span>}
          {refetch && (
            <Button
              size='medium'
              hierarchy='secondary'
              color='neutral'
              onClick={refetch}
              icon={<ArrowPathIcon />}
              label={<FormattedMessage id='Autogen_common.r251126.s_Refresh' />}
            />
          )}
        </div>
      )}
      {onClickExport && (
        <Button
          size='medium'
          hierarchy='secondary'
          color='neutral'
          icon={<DownloadIcon />}
          label={<FormattedMessage id='Autogen_common.r251126.s_Export' />}
          css={{ minW: { tabletDown: '100%' } }}
          onClick={onClickExport}
        />
      )}
    </div>
  );
};

export default ActionButtons;
